import { get, post } from './request'
import { utilities } from '@billow/js-helpers'

export let paginate = (path, success, failure) => {
  return get(
    `api${path}`, success, failure
  )
}

export let load = (article, success, failure) => get(
  `api/article/${article}`, success, failure
)

export let create = (article, success, failure) => post(
  `api/article/create`, article, success, failure
)

export let save = (article, success, failure) => post(
  `api/article/${article.id}/update`, article, success, failure
)

export let saveFile = (payload, success, failure) => {

  return post(
    `api/article/${payload.articleId}/file/update`,
    utilities.formData(payload),
    success,
    failure
  )
}

export let removeFile = (article, success, failure) => post(
  `api/article/${article}/file/remove`, {}, success, failure
)

export let remove = (article, success, failure) => post(
  `api/article/${article}/remove`, {}, success, failure
)